import React, { useEffect, useRef, useState } from "react";
import { getLastMonthRange } from "../utils/Date.util";
import api from "../config/Axios.config";
import BlogStyle4 from "./BlogStyle4";

const HomeLastMonthSection = () => {
    const [activeCategory, setActiveCategory] = useState("ALL");
    const [posts, setPosts] = useState(null);
    const cancelTokenSource = useRef(null);

    const fetchPosts = async (category) => {
        // Cancel the previous request if it exists
        console.log(cancelTokenSource);
        if (cancelTokenSource.current) {
            cancelTokenSource.current.abort(); // Abort the previous request
        }

        // Create a new AbortController
        cancelTokenSource.current = await new AbortController();

        const { firstDay, lastDay } = getLastMonthRange();
        let params = {
            from_date: firstDay,
            to_date: lastDay,
        };
        if (category !== "ALL") {
            params.categories = [category];
        }

        try {
            const response = await api.post(
                "/posts/filter",
                params,
                { signal: cancelTokenSource.current.signal } // Pass the signal for cancellation
            );
            console.log(category);
            console.log(response);
            setPosts(response.data.data); // Set posts data
        } catch (error) {
            if (error.name === "AbortError") {
                console.log("Request canceled");
            } else {
                console.error("Error fetching posts:", error);
            }
        }
    };

    const handleCategoryClick = (category) => {
        setPosts(null);
        setActiveCategory(category); // Update the active chip
        fetchPosts(category); // Fetch posts for the selected category
    };

    useEffect(() => {
        fetchPosts(activeCategory);
    }, []);

    return (
        <section className="space">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col">
                        <h2 className="sec-title has-line">Last Month</h2>
                    </div>
                    <div className="col-auto">
                        <div className="sec-btn">
                            <div className="filter-menu filter-menu-active">
                                {[
                                    "ALL",
                                    "World",
                                    "Business",
                                    "Technology",
                                    "Market",
                                    "Sports",
                                    "Health Care",
                                ].map((category) => (
                                    <button
                                        key={category}
                                        className={`tab-btn ${
                                            activeCategory === category
                                                ? "active"
                                                : ""
                                        }`}
                                        type="button"
                                        onClick={() =>
                                            handleCategoryClick(category)
                                        }
                                    >
                                        {category}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row gy-30 filter-active">
                    {!posts ? (
                        <p>Loading...</p>
                    ) : posts.length === 0 ? (
                        <p>
                            No News{" "}
                            {activeCategory === "ALL"
                                ? null
                                : `about ${activeCategory}`}{" "}
                            since Last Month
                        </p>
                    ) : (
                        posts.map((post) => (
                            <div
                                key={post.id}
                                className="col-lg-6 two-column filter-item"
                            >
                                <BlogStyle4 post={post} />
                            </div>
                        ))
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeLastMonthSection;
